import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { setCurrentRestaurant } from 'redux/common/actions';
import { useUser } from 'redux/user/use-user';
import { useDispatch } from 'react-redux';
import RestaurantsApi from 'libs/api/restaurants';

const api = new RestaurantsApi();

export const useSuperAdmin = () => {
  const dispatch = useDispatch();
  const { restaurantId } = useParams();
  const { isSuperAdmin, getInProcess } = useUser();

  useEffect(() => {
    if (getInProcess || !isSuperAdmin || !restaurantId) {
      return;
    }

    (async () => {
      try {
        const { data: { restaurant } } = await api.get(restaurantId);
        dispatch(setCurrentRestaurant(restaurant));
      } catch (e) {
      } finally {
      }
    })();
  }, [restaurantId, isSuperAdmin, dispatch, getInProcess]);

  return {
    restaurantId,
  };
};
